module.exports = __webpack_public_path__ + "static/media/nestle-splash-screen.1574f303.jpg";